import { defineMessages } from 'react-intl'
import { loadLanguageData, isLanguageCached } from './language-loader.js'
import LocaleHelper from '../LocaleHelper.js'

const defaultLocale = LocaleHelper.DEFAULT_LOCALE

const currentLocale = LocaleHelper.getCurrentLocale()

const getDefaultMessages = async () => {
    const targetLocale = currentLocale

    try {
        const translations = await loadLanguageData(targetLocale)
        
        if (translations) {
            const localeMessages = translations[targetLocale] || translations[defaultLocale]
            return defineMessages(localeMessages)
        } else {
            return {}
        }
    } catch (error) {
        return {}
    }
}

const areTranslationsLoaded = () => {
    return isLanguageCached(currentLocale)
}

const preloadTranslations = () => {
    loadLanguageData(currentLocale)
}

preloadTranslations()

export { 
    getDefaultMessages, 
    areTranslationsLoaded
}
